import { useEffect } from "react";
import Header from "../../components/AdminPortal/Header/Header";
import EditVideoComponent from "../../components/AdminPortal/Videos/EditVideo";
import { useGetVideoQuery } from "../../features/videos/videosApi";
import { useParams } from "react-router-dom";
export default function EditVideo() {
  useEffect(() => {
    document.title = "Edit Video - LWS Learning Portal";
  }, []);
  const { videoId } = useParams();
  const { data: video, isLoading, isError } = useGetVideoQuery(videoId);
  let content = null;
  if (isLoading) content = <p>Loading....</p>;
  if (!isLoading && isError) content = <p>Error</p>;
  if (!isLoading && !isError && video?.id)
    content = <EditVideoComponent video={video} />;
  return (
    <>
      <Header />
      <section className="py-6 bg-primary ">
        <div className="mx-auto px-5 lg:px-0" style={{ maxWidth: "45%" }}>
          <h4 className="mb-8 text-xl font-bold text-center">
            Please fillup the form to edit video
          </h4>
          {content}
        </div>
      </section>
    </>
  );
}
